// Mirrors backend/utils/adjustments.js so the form can preview totals before saving.
const round2 = (n) => Math.round(n * 100) / 100;

export const adjustmentAmount = (base, type, value) => {
  if (!type || value === null || value === undefined || value === "") return 0;
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return type === "percentage" ? round2((Number(base) * n) / 100) : round2(n);
};

// Taxes are the invoice's own snapshot: percentages follow the new base, absolute ones stay.
export const previewTotals = (base, extraCharge, discount, deduction, taxes) => {
  const extra = adjustmentAmount(base, extraCharge.type, extraCharge.value);
  const disc = adjustmentAmount(base, discount.type, discount.value);
  const deduct = adjustmentAmount(base, deduction.type, deduction.value);
  const beforeTaxes = round2(Number(base) + extra - disc - deduct);
  const taxLines = (taxes ?? []).map((t) => ({
    ...t,
    amount: t.type === "percentage" ? round2((beforeTaxes * Number(t.rate)) / 100) : Number(t.amount),
  }));
  const taxTotal = round2(taxLines.reduce((sum, t) => sum + t.amount, 0));
  return { extra, discount: disc, deduction: deduct, beforeTaxes, taxLines, taxTotal, total: round2(beforeTaxes + taxTotal) };
};

// "—" when a line has no adjustment of that kind.
export const adjustmentLabel = (row, kind) =>
  row?.[`${kind}_type`] ? Number(row[kind] || 0).toFixed(2) : "—";

// Amount plus the rate for percentages, e.g. "7.80 (10%)".
export const adjustmentDetail = (row, kind) => {
  if (!row?.[`${kind}_type`]) return "—";
  const amount = Number(row[kind] || 0).toFixed(2);
  return row[`${kind}_type`] === "percentage"
    ? `${amount} (${Number(row[`${kind}_value`])}%)`
    : amount;
};
